import React, { useState, useEffect } from 'react';
import ButtonItemPreview from './ButtonItemPreview';
import './ButtonPreview.scss';

const ButtonPreview = props => {
	const { from, margin, button, style } = props;

	const { text = '', buttonColor = '', textColor = '', onPress = {}, position = '', source = '' } =
		(button && button.props) || {};
	const [buttonProps, setButtonProps] = useState([]);

	useEffect(() => {
		// backwards compatibility TO BE DELETED
		if (button && !button.props.buttons)
			setButtonProps([{ text, buttonColor, textColor, onPress, position, source }]);
		else setButtonProps(button?.props?.buttons || []);
	}, [button]);

	const fromButton = from === 'WidgetButton';

	return (
		<div className="WidgetPreviews">
			<div className={!from ? 'hover-wrap' : null} style={{ height: '100%' }}>
				{!from && (
					<div className="hover-container" style={{ borderRadius: '15px' }}>
						Button
					</div>
				)}
				<div>
					{fromButton ? (
						<div
							className="button-preview"
							style={{
								margin,
								width: '100%',
								height: '100%',
								backgroundColor: '#AAAAAA',
								color: '#FFFFFF',
								...style,
							}}
						>
							Button
						</div>
					) : (
						<div className="buttons-row" style={{ margin }}>
							{buttonProps.length &&
								buttonProps.map((button, index) => (
									<ButtonItemPreview
										button={button}
										style={style}
										from={from}
										key={'button-item-' + props.button.id + '-' + index}
									/>
								))}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ButtonPreview;
